import Blockly from "blockly";

// 注册渲染器
import "./gta/renderer";
import "./gta/core/block_dragger.js";

export default Blockly;
